import React, { useEffect, useRef } from 'react';
import { X } from 'lucide-react';
import { cn } from '../../lib/utils';
import { Button } from './Button';
interface DialogProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title?: string;
  description?: string;
}
export function Dialog({
  isOpen,
  onClose,
  children,
  title,
  description
}: DialogProps) {
  const overlayRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center" data-id="element-355">
      {/* Overlay */}
      <div ref={overlayRef} className="fixed inset-0 bg-black/70 backdrop-blur-sm transition-opacity" onClick={onClose} data-id="element-356" />

      {/* Content */}
      <div ref={contentRef} className="relative z-50 w-full max-w-lg transform rounded-lg border-2 border-accent bg-[#1A1A2E] p-6 shadow-2xl transition-all animate-in fade-in zoom-in-95 duration-200" role="dialog" aria-modal="true" data-id="element-357">
        <div className="flex items-center justify-between mb-4" data-id="element-358">
          {title && <h2 className="text-xl font-bold text-white" data-id="element-359">{title}</h2>}
          <Button variant="ghost" size="icon" onClick={onClose} className="absolute right-4 top-4 text-gray-400 hover:text-white" data-id="element-360">
            <X className="h-5 w-5" data-id="element-361" />
            <span className="sr-only" data-id="element-362">Close</span>
          </Button>
        </div>

        {description && <p className="text-sm text-gray-400 mb-6" data-id="element-363">{description}</p>}

        <div className="mt-2" data-id="element-364">{children}</div>
      </div>
    </div>;
}
export function DialogFooter({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2 mt-6', className)} {...props} data-id="element-365" />;
}